import { defineComponent as r, ref as d, nextTick as b, h as f } from "vue";
import u from "./ghl-ui.es233.js";
const o = r({
  __TAB_PANE__: !0,
  props: {
    name: {
      type: [String, Number]
    },
    tab: {
      type: String || Object || Function
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(n, { slots: e, expose: i }) {
    const t = d(null);
    return i({
      syncBarPosition: () => {
        b(() => {
          var a;
          return (a = t.value) == null ? void 0 : a.syncBarPosition();
        });
      }
    }), () => f(
      u,
      {
        ref: t,
        name: n.name,
        tab: n.tab,
        disabled: n.disabled
      },
      e.default ? () => {
        var a;
        return (a = e == null ? void 0 : e.default) == null ? void 0 : a.call(e);
      } : void 0
    );
  }
});
export {
  o as default
};
